import React, { Component, createRef, forwardRef, useState, useEffect, useImperativeHandle, useRef } from 'react';
import { Switch, Route, NavLink } from 'react-router-dom';
import { ThemeProvider, createTheme, withStyles } from "@material-ui/core/styles";
import { Menu, Close, CloseRounded, RefreshRounded, MoreHorizRounded, AddPhotoAlternateRounded, SendRounded, AutorenewRounded, } from '@material-ui/icons';
import { Grid, Box, AppBar, IconButton, Typography, Toolbar, ListItemText, ListItem, ButtonGroup, Button, TextareaAutosize, Popper, Grow, ClickAwayListener, MenuList, MenuItem, Paper } from '@material-ui/core';
import { SnackbarProvider, } from 'notistack';
import RouterBreadcrumb from './RouterBreadcrumb';
import RouterFooter from './RouterFooter';
import RouterMenu from './RouterMenu';
import SidebarItem from './SidebarItem';
import MessageBadge from "./MessageBadge";
import { LoginOutModal } from './Modal';
import { CircleProgress } from './Overlay';
import { get_ESD_indexedDB_factory, isMobile, permissionLoop } from '../js/function';
import { checkSign, esd_storage, getPermision } from '../js/Domain';
import { SystemSettings } from '../js/api.ts';
import { TourProvider } from '@reactour/tour';
import { ReactTextBtn } from '../_AAA/components/ReactButton';
import { ApiProvider } from '../js/apiProvider';
import { useChatbotApi, ChatbotParams, ChatRecordSearchParams } from "../js/adapter/ChatbotAdapter";
import { MyFavoriteIcon, MyFavoritePageProvider } from './RecordMostUsedPage';
import { SignalRProvider } from '../js/SignalR/SignalRContext';
import { ThemeSetContext, ThemeSetProvider } from './ThemeSet';
import { MainPageDialogProvider } from '../js/MainPageDialogContext';
import MainPageDialog from './MainPageDialog';
import MainPageMask from './MainPageMask';
import { MainPageMaskProvider } from '../js/MainPageMaskContent';
import OpenNewWindowButton from './OpenNewWindowButton';

// Snackbar 顏色->撰寫於 css 檔案了
const styles = {
};
/** 使用 MUI 默認主題 */
const theme = createTheme();



class RouterMainPage extends Component {
    static contextType = ThemeSetContext; // 指定 Context
    constructor(props) {
        super(props);
        this.state = {
            // locatPath: window.location.pathname.split('/').filter((x) => x != ""),
            modal: null,                // modal內容及功能
            modalOpen: false,           // modal開關
            punchCardPermision: false,
            isDotNet6: localStorage.getItem("defaultApiVersion") === "dotNet6",
            systemName: "",
        };
        this.sidebarRef = createRef();
        this.sidebarAIRef = createRef();
    }

    componentDidMount = async () => {
        // 判斷按鈕權限
        checkSign().then(async loginRes => {
            if (loginRes.success) {
                getPermision(loginRes.data.path).then(async data => {
                    console.log(data)
                    let PunchCard = ['Humanresources', 'sidebar', 'PunchCard'];

                    let resSystemSetting = await SystemSettings.SystemSettingSearch({ ssm_name: "系統基本設定" });
                    if (resSystemSetting.success) {
                        if (resSystemSetting.data.length > 0) {
                            let resSystemName = await JSON.parse(resSystemSetting.data[0].value_json);
                            this.setState({
                                systemName: resSystemName[0].value || ''
                            });
                        }
                    }

                    // 是否有出勤管理頁面
                    this.setState({
                        punchCardPermision: await permissionLoop(PunchCard, data.items, 0),
                    });
                });
            }
        });
    }

    handleDrawer = () => {
        this.sidebarRef.current.handleDrawer();
    };

    handleClick = (e) => {
        if (e.currentTarget.children != undefined) {
            sessionStorage.home_page_name = e.currentTarget.children[0].innerText;
            let menuBtn = e.currentTarget.getAttribute("data-id");
            if (menuBtn !== sessionStorage.home_page) {
                sessionStorage.home_page = menuBtn;
                this.props.history.push('/Index/Home');
                window.location.reload();
            }

        }
    }

    handleAIDrawer = () => {
        this.sidebarAIRef.current.handleAIDrawer();
    };

    render() {
        const themeColor = this.context.themeColor; // 獲取 Context 中的值

        const systemName = this.state.systemName || (sessionStorage.getItem("company_name") === "undefined" ? "" : sessionStorage.getItem("company_name"))

        return (
            <TourProvider
                afterOpen={() => { document.querySelector('.contentMain').style.overflow = 'hidden' }}
                beforeClose={() => { document.querySelector('.contentMain').style.overflow = 'auto' }}
                scrollSmooth
                showDots={false} //不顯示步驟點
                disableInteraction //highlight內不可互動(可在需互動step中另外開放)
                disableKeyboardNavigation //無法使用鍵盤操作(避免跳步)
                disableDotsNavigation //無法使用點選步驟點跳步
                //點擊遮罩區跳至下一步
                onClickMask={(clickProps) => {
                    //     if (clickProps.steps.length === clickProps.currentStep + 1) {
                    //         clickProps.setIsOpen(false)
                    //     } else { clickProps.setCurrentStep((prev) => prev + 1) }
                }}

                steps={[]}
                styles={{ //自訂CSS style
                    popover: (base) => ({
                        ...base,
                        '--reactour-accent': themeColor?.secondary, //右上提示角 與 dot active 時的顏色
                        textAlign: 'center',
                        backgroundColor: '#fff',
                        borderRadius: 10,
                        transform: 'scale(1)'
                    }),
                    maskArea: (base) => ({ ...base, rx: 10 }), //spolight
                    maskWrapper: (base) => ({ ...base, color: '#131313ab' }),
                    badge: (base) => ({ ...base, left: 'auto', right: '-0.8125em' }),
                    controls: (base) => ({ ...base, marginTop: 30, justifyContent: 'flex-end' }),
                    close: (base) => ({ ...base, right: 'auto', left: 8, top: 8 }),
                }}
                // 下一步鈕
                nextButton={(props) => {
                    if (props.stepsLength - 1 > props.currentStep) {
                        return <ReactTextBtn
                            size="medium"
                            // icon={<NavigateNext />}
                            color='secondary'
                            variant="contained"
                            text={'Next'}
                            click={() => props.setCurrentStep(prev => prev + 1)} />
                    } else {
                        return <ReactTextBtn
                            text="End"
                            variant="outlined"
                            style={{ padding: '1px', minWidth: "45px" }}
                            click={() => props.setIsOpen(false)} />
                    }
                }}
                // 上一步鈕
                prevButton={(props) => {
                    if (props.currentStep === 0) {
                        return null
                    } else {
                        return <ReactTextBtn
                            style={{ backgroundColor: 'transparent', border: 'none' }}
                            size="medium"
                            // icon={<NavigateBefore />}
                            variant="outlined"
                            text='Back'
                            click={() => props.setCurrentStep(prev => prev - 1)}
                            disabled={props.currentStep === 0 ? true : false} />
                    }
                }}
                // 右上角提示步驟
                badgeContent={({ totalSteps, currentStep }) => (
                    `${currentStep + 1}/${totalSteps}`
                )}
            >
                <SignalRProvider>
                    <ApiProvider>
                        <MyFavoritePageProvider>
                            <ThemeProvider theme={theme}>
                                <AppBar position="fixed" style={{ zIndex: "1300", height: "56px" }}>
                                    <Toolbar>
                                        <IconButton
                                            color="inherit"
                                            aria-label="open drawer"
                                            onClick={this.handleDrawer}
                                            edge="start">
                                            <Menu />
                                        </IconButton>
                                        <Typography variant="h4" noWrap>
                                            {systemName}
                                        </Typography>
                                        <Box display={{ xs: "none", sm: 'none', md: "block" }}>
                                            <ButtonGroup disableElevation variant="contained" color="primary" style={{ margin: "0px 20px" }}>
                                                {this.props.navRes.children.map((item, index) => { // 選單
                                                    let active = item.code === sessionStorage.home_page ? "active" : "";
                                                    return <Button key={item.code} data-id={item.code} onClick={this.handleClick}
                                                        style={{ padding: "5px 10px" }} className={active} aria-label="topMainNavBar">{item.name}</Button>
                                                })}
                                            </ButtonGroup>
                                        </Box>
                                        <RouterMenu history={this.props.history}
                                            navRes={this.props.navRes}
                                            hasPunchCard={this.state.punchCardPermision}
                                        />
                                        <MyFavoriteIcon />
                                        <MessageBadge />
                                    </Toolbar>
                                </AppBar >
                                <SidebarDrawer ref={this.sidebarRef} {...this.props} />
                                <main className={"contentMain"}>
                                    <RouterBreadcrumb sidebarRes={this.props == undefined ? null : this.props.sidebarRes} />
                                    <Grid item xs={12} style={{ minHeight: "calc(100% - 98px)", overflow: "hidden" }}>
                                        <Box style={{ width: "100%", padding: "1.5rem" }}>
                                            {this.props.isRouterLoaded ? "" : <LoginOutModal modal={true} history={this.props.history} />}
                                            {this.props.isRouterLoaded ? <RouterMain sidebarRes={this.props.sidebarRes} /> : <CircleProgress />}
                                        </Box>
                                    </Grid>
                                    <RouterFooter />
                                </main>
                                <MainPageDialog />
                                <MainPageMask />
                            </ThemeProvider>
                        </MyFavoritePageProvider>
                    </ApiProvider>
                </SignalRProvider>
            </TourProvider>
        );
    }
}

/**
 * @description 右側 聊天機器人
 */
const AiSidebarDrawer = forwardRef((props, ref) => {
    const [openAISideBar, setOpenAISideBar] = useState(false);
    const [list, setList] = useState([
        { id: "AI0003", title: "我想要請假怎麼申請" },
        { id: "AI0004", title: "如何清除系統快取" }
    ]);
    const [textValue, setTextValue] = useState("");
    const [submittedText, setSubmittedText] = useState([]);
    const [additionalText, setAdditionalText] = useState("");
    const [open, setOpen] = useState(false);
    const [page, setPage] = useState(1); // 當前頁數
    const [loading, setLoading] = useState(false); // 是否正在加載對話紀錄
    const [showLoadMore, setShowLoadMore] = useState(false); // 是否顯示載入更多按鈕
    const anchorRef = useRef(null);
    const scrollRef = useRef(null); // 用來追蹤滾動狀態
    const chatbotApiManager = useChatbotApi();
    const [isAiResponding, setIsAiResponding] = useState(false); // 是否 AI 正在回覆

    // 初始化 AiSidebarDrawer 時，載入對話紀錄
    // useEffect(() => {
    //     localStorage.setItem('chatPage', 1)
    //     if (chatbotApiManager && openAISideBar) {
    //         const storedPage = localStorage.getItem('chatPage') || 1;
    //         setPage(parseInt(storedPage));
    //         loadChatRecords(parseInt(storedPage)); // 載入 localStorage 中的頁數
    //     }
    // }, [chatbotApiManager, openAISideBar]);

    // 滾動到最底部的初始化
    useEffect(() => {
        if (scrollRef.current) {
            scrollRef.current.scrollTop = scrollRef.current.scrollHeight;
        }
    }, [openAISideBar]);


    useEffect(() => {
        if (chatbotApiManager && openAISideBar) {
            loadChatRecords(1);  // 預設載入第一頁
            localStorage.setItem('currentPage', page);
        }
    }, [chatbotApiManager, openAISideBar]);

    // 當對話資料更新時自動滾動到最底部
    useEffect(() => {
        if (scrollRef.current) {
            scrollRef.current.scrollTop = scrollRef.current.scrollHeight;
        }
    }, [submittedText]);

    // 監聽滾動事件
    const handleScroll = (event) => {
        const { scrollTop } = event.target;
        console.log('Scroll Top:', scrollTop); // 檢查滾動位置
        // 檢查是否捲到頂部，顯示載入更多按鈕
        if (scrollTop === 0 && !loading) {
            setShowLoadMore(true); // 顯示載入更多按鈕
        }
    };


    // 修改loadChatRecords函數
    const loadChatRecords = async (currentPage) => {
        if (loading) return;
        setLoading(true);
        try {
            const res = await chatbotApiManager.ChatRecordSearch({
                user_id: esd_storage.user_id,
                page: currentPage,
                num_per_page: 10,
            });
            if (res.success && res.data.length > 0) {
                // 儲存頁碼到 localStorage
                localStorage.setItem('chatPage', res.page);
                setSubmittedText((prev) => [...res.data, ...prev]);
                setPage(currentPage);
                localStorage.setItem('currentPage', currentPage);
            }
        } catch (error) {
            console.error("載入對話紀錄失敗", error);
        } finally {
            setLoading(false);
            setShowLoadMore(false);
        }
    };


    // 點擊載入更多按鈕
    const handleLoadMore = () => {
        const chatPage = parseInt(localStorage.getItem('chatPage')) || 1;
        const currentScrollPosition = scrollRef.current.scrollTop;

        if (page >= chatPage) {
            setShowLoadMore(false);  // 隱藏按鈕
        } else {
            loadChatRecords(page + 1).then(() => {
                scrollRef.current.scrollTop = currentScrollPosition;
            });
        }
    };


    const handleAIDrawer = () => {
        setOpenAISideBar(!openAISideBar);
    };

    useImperativeHandle(ref, () => ({
        handleAIDrawer,
    }));

    const handleSend = async () => {
        if (textValue.trim() && !isAiResponding) { // 檢查是否 AI 正在回覆
            setIsAiResponding(true); // 鎖住輸入框和按鈕

            // 新增使用者訊息到對話紀錄中
            setSubmittedText((prev) => [...prev, { msg: textValue, isUser: true }]);
            setAdditionalText("AI 正在回覆中...");
            setTextValue("");

            try {
                const res = await chatbotApiManager.Chatbot({
                    msg: textValue,
                    msg_type: "text",
                    tag: ""
                });
                if (res.success) {
                    // 將 AI 的回覆新增到對話紀錄中，並標記為非使用者的訊息
                    setSubmittedText((prev) => [...prev, { msg: res.data.msg, isUser: false }]);
                    setAdditionalText(""); // 清空暫時提示
                    localStorage.setItem('chatPage', res.page);
                } else {
                    setAdditionalText("AI回覆失敗，請再試一次。");
                }
            } catch (error) {
                console.error("API 呼叫失敗", error);
                setAdditionalText("AI回覆失敗，請再試一次。");
            } finally {
                setIsAiResponding(false); // 解鎖輸入框和按鈕
            }
        }
    };


    // const handleSend = async () => {
    //     if (textValue.trim()) {
    //         // 新增使用者訊息到對話紀錄中
    //         setSubmittedText((prev) => [...prev, { msg: textValue, isUser: true }]);
    //         setAdditionalText("AI 正在回覆中...");
    //         setTextValue("");

    //         try {
    //             const res = await chatbotApiManager.Chatbot({
    //                 msg: textValue,
    //                 msg_type: "text",
    //                 tag: ""
    //             });
    //             if (res.success) {
    //                 // 將 AI 的回覆新增到對話紀錄中，並標記為非使用者的訊息
    //                 setSubmittedText((prev) => [...prev, { msg: res.data.msg, isUser: false }]);
    //                 setAdditionalText(""); // 清空暫時提示
    //                 localStorage.setItem('chatPage', res.page);
    //             } else {
    //                 // 如果 AI 回覆失敗，顯示失敗訊息
    //                 setAdditionalText("AI回覆失敗，請再試一次。");
    //             }
    //         } catch (error) {
    //             console.error("API 呼叫失敗", error);
    //             setAdditionalText("AI回覆失敗，請再試一次。");
    //         }
    //     }
    // };

    const handleRefresh = () => {
        loadChatRecords(1);  // 預設載入第一頁
        localStorage.setItem('currentPage', 1);
    };


    const handleKeyDown = (event) => {
        if (event.key === "Enter" && !event.shiftKey) {
            event.preventDefault();
            handleSend();
        }
    };

    const handleToggle = () => {
        setOpen(!open);
    };

    const handleClose = (event) => {
        if (anchorRef.current && anchorRef.current.contains(event.target)) {
            return;
        }
        setOpen(false);
    };

    const handleListKeyDown = (event) => {
        if (event.key === 'Tab') {
            event.preventDefault();
            setOpen(false);
        } else if (event.key === 'Escape') {
            setOpen(false);
        }
    };


    const handleRandomList = () => {
        setList([
            { id: "AI0003", title: "我想要請假怎麼申請" },
            { id: "AI0004", title: "如何清除系統快取" }
        ]);
    };

    const sidebarShift = openAISideBar ? "" : " sidebarAIDrawerShift";

    return (
        <>
            <Box className={"sidebarAIDrawer" + (openAISideBar ? "" : " sidebarAIDrawerShift")} open={openAISideBar} style={{ overflow: "hidden" }}>
                <Toolbar style={{ width: 300 }} />
                <Box style={{ height: "44px", display: "flex", justifyContent: "space-between" }}>
                    <Box noWrap sx={{ display: "flex", padding: "5px 20px", alignItems: "center" }}>
                        <Typography style={{ whiteSpace: "nowrap", margin: "0 0 0 10px", fontWeight: "bold", color: "#4d5c71" }}>AI 助理</Typography>
                    </Box>
                    <Box sx={{ display: "flex", alignItems: "center" }}>
                        <IconButton
                            disableFocusRipple
                            ref={anchorRef}
                            color="inherit"
                            aria-controls={open ? 'composition-menu' : undefined}
                            aria-expanded={open ? 'true' : undefined}
                            aria-haspopup="true"
                            onClick={handleToggle}
                            style={{ height: "100%", padding: "5px 10px", borderRadius: "0", color: "#4d5c71" }}
                        >
                            <MoreHorizRounded />
                        </IconButton>
                        <Popper open={open} anchorEl={anchorRef.current} role={undefined} placement="bottom-start" transition disablePortal>
                            {({ TransitionProps, placement }) => (
                                <Grow {...TransitionProps} style={{ transformOrigin: placement === 'bottom-start' ? 'left top' : 'left bottom', }}>
                                    <Paper>
                                        <ClickAwayListener onClickAway={handleClose}>
                                            <MenuList style={{ fontSize: "13px" }} autoFocusItem={open} onKeyDown={handleListKeyDown}>
                                                <MenuItem style={{ fontSize: "13px" }} onClick={handleClose}>深入了解</MenuItem>
                                                <MenuItem style={{ fontSize: "13px" }} onClick={handleClose}>使用規定</MenuItem>
                                                <MenuItem style={{ fontSize: "13px" }} onClick={handleClose}>隱私權聲明</MenuItem>
                                            </MenuList>
                                        </ClickAwayListener>
                                    </Paper>
                                </Grow>
                            )}
                        </Popper>
                        <IconButton disableFocusRipple color="inherit" onClick={handleRefresh} style={{ height: "100%", padding: "5px 10px", borderRadius: "0", color: "#4d5c71" }}>
                            <RefreshRounded />
                        </IconButton>
                        <IconButton disableFocusRipple color="inherit" onClick={handleAIDrawer} style={{ height: "100%", padding: "5px 10px", borderRadius: "0", color: "#4d5c71" }}>
                            <CloseRounded />
                        </IconButton>
                    </Box>
                </Box>
                <Box ref={scrollRef} onScroll={handleScroll} style={{ height: "calc(100% - 194px)", overflow: "auto", display: "flex", flexDirection: "column", padding: "10px 20px 10px 20px" }}>
                    {showLoadMore && (
                        <Button onClick={handleLoadMore} disabled={loading} style={{ margin: "10px auto", display: "block" }}>
                            {loading ? "載入中..." : "載入更多"}
                        </Button>
                    )}
                    {submittedText.length > 0 ? (
                        <AiSendList list={submittedText} additionalText={additionalText} />
                    ) : (
                        <Box style={{ width: "100%", padding: "50px 0", display: "flex", flexDirection: "column", justifyContent: "center", margin: "0 auto" }}>
                            <Box style={{ height: "60px", whiteSpace: "nowrap", fontWeight: "bold", justifyContent: "center", color: "#c4c4c7", display: "flex", alignItems: "center" }}>
                                您好，請隨意向我提問或選擇建議以開始
                            </Box>
                            {/* 還沒有這個功能
                            <AiRandomList list={list} /> 
                            <IconButton disableFocusRipple color="inherit" onClick={handleRandomList} style={{ padding: "5px 10px", width: "fit-content", borderRadius: "0.5rem", color: "#4d5c71", margin: "auto" }}>
                                <AutorenewRounded />
                            </IconButton> */}
                        </Box>
                    )}
                </Box>
                {/* Textarea 和按鈕部分 */}
                <Box style={{ height: "150px", width: "100%", background: "#ffff", boxShadow: "inset 1px 1px 0px 0px #e8e8e8" }}>
                    <TextareaAutosize
                        maxRows={4}
                        style={{ height: "calc(100% - 44px)", width: "100%", border: "none", background: "transparent", padding: "10px 15px", color: "rgb(77, 92, 113)", outline: "none", resize: "none", overflow: "auto" }}
                        placeholder="請問我任何問題 ...."
                        value={textValue}
                        onKeyDown={handleKeyDown}
                        disabled={isAiResponding}
                        onChange={(e) => setTextValue(e.target.value)}
                    />
                    <Box sx={{ height: "44px", display: "flex", alignItems: "center", justifyContent: "start", position: "absolute", bottom: 0 }}>
                        <IconButton disableFocusRipple color="inherit"
                            disabled={isAiResponding}
                            style={{ height: "100%", padding: "5px 10px", borderRadius: "0", color: "#4d5c71" }}>
                            <AddPhotoAlternateRounded />
                        </IconButton>
                        <IconButton disableFocusRipple color="inherit" onClick={handleSend}
                            disabled={isAiResponding}
                            style={{ height: "100%", padding: "5px 10px", borderRadius: "0", color: "#4d5c71" }}>
                            <SendRounded />
                        </IconButton>
                    </Box>
                </Box>
            </Box>
        </>
    );
});

// const AiSidebarDrawer = forwardRef((props, ref) => {
//     const [openAISideBar, setOpenAISideBar] = useState(false);
//     const [list, setList] = useState([
//         { id: "AI0003", title: "我想要請假怎麼申請" },
//         { id: "AI0004", title: "如何清除系統快取" }
//     ]);
//     const [textValue, setTextValue] = useState("");
//     const [submittedText, setSubmittedText] = useState([]);
//     const [additionalText, setAdditionalText] = useState("");
//     const [open, setOpen] = useState(false);
//     const [page, setPage] = useState(1); // 當前頁數
//     const [loading, setLoading] = useState(false); // 是否正在加載對話紀錄
//     const anchorRef = useRef(null);
//     const scrollRef = useRef(null); // 用來追蹤滾動狀態
//     const chatbotApiManager = useChatbotApi();

//     // 初始化 AiSidebarDrawer 時，載入對話紀錄
//     useEffect(() => {
//         localStorage.setItem('chatPage', 1)
//         if (chatbotApiManager && openAISideBar) {
//             const storedPage = localStorage.getItem('chatPage') || 1;
//             setPage(parseInt(storedPage));
//             loadChatRecords(parseInt(storedPage)); // 載入 localStorage 中的頁數
//         }
//     }, [chatbotApiManager, openAISideBar]);

//     // 滾動到最底部的初始化
//     useEffect(() => {
//         if (scrollRef.current) {
//             scrollRef.current.scrollTop = scrollRef.current.scrollHeight;
//         }
//     }, [openAISideBar]);

//     // 當對話資料更新時自動滾動到最底部
//     useEffect(() => {
//         if (scrollRef.current) {
//             scrollRef.current.scrollTop = scrollRef.current.scrollHeight;
//         }
//     }, [submittedText]);

//     // 監聽滾動事件
//     const handleScroll = (event) => {
//         const { scrollTop, scrollHeight, clientHeight } = event.target;
//         // 檢查是否捲到頂部，載入下一頁
//         if (scrollTop === 0 && !loading) {
//             loadChatRecords(page + 1); // 載入上一頁
//         }
//     };

//     // 載入對話紀錄
//     const loadChatRecords = async (targetPage) => {
//         if (loading) return;
//         setLoading(true);
//         try {
//             const res = await chatbotApiManager.ChatRecordSearch({
//                 user_id: esd_storage.user_id,
//                 page: targetPage,
//                 num_per_page: 10,
//             });
//             if (res.success) {
//                 if (res.data.length > 0) {
//                     // 資料追加到已存在資料
//                     setSubmittedText((prev) => [...prev, ...res.data]);
//                     setPage(targetPage);
//                     localStorage.setItem('chatPage', targetPage); // 更新頁碼到 localStorage
//                 } else if (targetPage === 1 && submittedText.length === 0) {
//                     // 如果是第一頁且無資料，顯示隨機列表
//                     handleRandomList();
//                 }
//             }
//         } catch (error) {
//             console.error("載入對話紀錄失敗", error);
//         } finally {
//             setLoading(false);
//         }
//     };

//     const handleAIDrawer = () => {
//         setOpenAISideBar(!openAISideBar);
//     };

//     useImperativeHandle(ref, () => ({
//         handleAIDrawer,
//     }));

//     const handleSend = async () => {
//         if (textValue.trim()) {
//             // 新增使用者訊息到對話紀錄中
//             setSubmittedText((prev) => [...prev, { msg: textValue, isUser: true }]);
//             setAdditionalText("AI 正在回覆中...");
//             setTextValue("");

//             try {
//                 const res = await chatbotApiManager.Chatbot({
//                     msg: textValue,
//                     msg_type: "text",
//                     tag: ""
//                 });
//                 if (res.success) {
//                     // 將 AI 的回覆新增到對話紀錄中，並標記為非使用者的訊息
//                     setSubmittedText((prev) => [...prev, { msg: res.data.msg, isUser: false }]);
//                     setAdditionalText(""); // 清空暫時提示
//                 } else {
//                     // 如果 AI 回覆失敗，顯示失敗訊息
//                     setAdditionalText("AI回覆失敗，請再試一次。");
//                 }
//             } catch (error) {
//                 console.error("API 呼叫失敗", error);
//                 setAdditionalText("AI回覆失敗，請再試一次。");
//             }
//         }
//     };


//     const handleToggle = () => {
//         setOpen(!open);
//     };

//     const handleClose = (event) => {
//         if (anchorRef.current && anchorRef.current.contains(event.target)) {
//             return;
//         }
//         setOpen(false);
//     };

//     const handleListKeyDown = (event) => {
//         if (event.key === 'Tab') {
//             event.preventDefault();
//             setOpen(false);
//         } else if (event.key === 'Escape') {
//             setOpen(false);
//         }
//     };

//     const handleKeyDown = (event) => {
//         if (event.key === 'Enter' && !event.shiftKey) {
//             event.preventDefault();
//             handleSend();
//         }
//     };

//     const handleRefresh = () => {
//         setSubmittedText([]);
//         setPage(1);
//         localStorage.removeItem('chatPage'); // 清除 localStorage 中的頁碼
//         loadChatRecords(1);
//     };

//     const handleRandomList = () => {
//         setList([
//             { id: "AI0003", title: "我想要請假怎麼申請" },
//             { id: "AI0004", title: "如何清除系統快取" }
//         ]);
//     };

//     const sidebarShift = openAISideBar ? "" : " sidebarAIDrawerShift";

//     return (
//         <>
//             <Box className={"sidebarAIDrawer" + sidebarShift} open={openAISideBar} style={{ overflow: "hidden" }}>
//                 {/* 省略部分 UI 元件 */}
//                 <Box ref={scrollRef} onScroll={handleScroll} style={{ height: "calc(100% - 194px)", display: "flex", width: "100%", justifyContent: "flex-start", flexDirection: "column", padding: "10px 20px", overflow: "auto" }}>
//                     {submittedText.length > 0 ? (
//                         <AiSendList list={submittedText} additionalText={additionalText} />
//                     ) : (
//                         <Box style={{ width: "100%", padding: "50px 0", display: "flex", flexDirection: "column", justifyContent: "center", margin: "0 auto" }}>
//                             <Box style={{ height: "60px", whiteSpace: "nowrap", fontWeight: "bold", justifyContent: "center", color: "#c4c4c7", display: "flex", alignItems: "center" }}>
//                                 您好，請隨意向我提問或選擇建議以開始
//                             </Box>
//                             <AiRandomList list={list} />
//                             <IconButton disableFocusRipple color="inherit" onClick={handleRandomList} style={{ padding: "5px 10px", width: "fit-content", borderRadius: "0.5rem", color: "#4d5c71", margin: "auto" }}>
//                                 <AutorenewRounded />
//                             </IconButton>
//                         </Box>
//                     )}
//                 </Box>

//                 {/* Textarea 和按鈕部分 */}
//                 <Box style={{ height: "150px", width: "100%", background: "#ffff", boxShadow: "inset 1px 1px 0px 0px #e8e8e8" }}>
//                     <TextareaAutosize
//                         maxRows={4}
//                         style={{ height: "calc(100% - 44px)", width: "100%", border: "none", background: "transparent", padding: "10px 15px", color: "rgb(77, 92, 113)", outline: "none", resize: "none", overflow: "auto" }}
//                         placeholder="請問我任何問題 ...."
//                         value={textValue}
//                         onKeyDown={handleKeyDown}
//                         onChange={(e) => setTextValue(e.target.value)}
//                     />
//                     <Box sx={{ height: "44px", display: "flex", alignItems: "center", justifyContent: "start", position: "absolute", bottom: 0 }}>
//                         <IconButton disableFocusRipple color="inherit" style={{ height: "100%", padding: "5px 10px", borderRadius: "0", color: "#4d5c71" }}>
//                             <AddPhotoAlternateRounded />
//                         </IconButton>
//                         <IconButton disableFocusRipple color="inherit" onClick={handleSend} style={{ height: "100%", padding: "5px 10px", borderRadius: "0", color: "#4d5c71" }}>
//                             <SendRounded />
//                         </IconButton>
//                     </Box>
//                 </Box>
//             </Box>
//         </>
//     );
// });

class AiRandomList extends Component {
    constructor(props) {
        super(props);
        this.state = {}
    }
    render() {
        const { list } = this.props;
        return (
            <>
                {list && list.length > 0 ? list.map((elem) =>
                    <Button key={elem.id} style={{
                        height: "fit-content",
                        minHeight: "40px",
                        padding: "6px 15px",
                        borderRadius: "0.6rem",
                        margin: "10px 0", display: "flex",
                        alignItems: "center",
                        justifyContent: "flex-start",
                        background: "#fff",
                        animation: "fadeInScaleUp 0.6s ease-in-out"
                    }}>
                        <svg width="17" height="17" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M15.5455 6.90909L16.625 4.53409L19 3.45455L16.625 2.375L15.5455 0L14.4659 2.375L12.0909 3.45455L14.4659 4.53409L15.5455 6.90909ZM9.06818 7.34091L6.90909 2.59091L4.75 7.34091L0 9.5L4.75 11.6591L6.90909 16.4091L9.06818 11.6591L13.8182 9.5L9.06818 7.34091ZM15.5455 12.0909L14.4659 14.4659L12.0909 15.5455L14.4659 16.625L15.5455 19L16.625 16.625L19 15.5455L16.625 14.4659L15.5455 12.0909Z" fill="#727B97" />
                        </svg>
                        <Typography style={{
                            whiteSpace: "nowrap", fontSize: "13px",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            margin: "0 0 0 15px", fontWeight: "bold", color: "#4d5c71"
                        }}>{elem.title}</Typography>
                    </Button>
                ) : ""}
            </>

        )
    }
}

class AiSendList extends Component {
    constructor(props) {
        super(props);
        this.state = {}
    }
    render() {
        const { list, additionalText } = this.props;
        return (
            <>
                {list && list.length > 0 ? list.map((elem, index) => {
                    const isRobotMessage = elem.isUser === false || elem.robot_id && elem.user_id;
                    const messageStyle = isRobotMessage
                        ? { margin: "10px auto 10px 0", background: "#cfe9ff" } // 左側訊息樣式
                        : { margin: "10px 0 10px auto", background: "rgb(239 239 241)" }; // 右側訊息樣式

                    return (
                        <Box key={index} style={{
                            height: "fit-content",
                            padding: "6px 15px",
                            borderRadius: "0.6rem",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "flex-start",
                            ...messageStyle,
                            animation: "fadeInScaleUp 0.6s ease-in-out"
                        }}>
                            <Typography style={{ fontSize: "13px", color: "rgb(77 92 113)" }}>{elem.msg}</Typography>
                        </Box>
                    );
                }) : ""}

                {additionalText &&
                    <Box style={{
                        height: "fit-content",
                        padding: "6px 15px",
                        borderRadius: "0.6rem",
                        margin: "10px auto 10px 0", // AI 回覆在左側
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "flex-start",
                        background: "#cfe9ff", // 顯示 AI 回覆的背景顏色
                        animation: "fadeInScaleUp 0.6s ease-in-out"
                    }}>
                        <Typography style={{ fontSize: "13px", color: "rgb(77 92 113)" }}>{additionalText}</Typography>
                    </Box>
                }
            </>
        );
    }
}



// class AiSendList extends Component {
//     constructor(props) {
//         super(props);
//         this.state = {}
//     }
//     render() {
//         const { list } = this.props;
//         return (
//             <>
//                 {list && list.length > 0 ? list.map((elem, index) =>
//                     <Box key={index} style={{
//                         height: "fit-content",
//                         minHeight: "40px",
//                         padding: "6px 15px",
//                         borderRadius: "0.6rem",
//                         margin: "10px 0 10px auto",
//                         display: "flex",
//                         alignItems: "center",
//                         justifyContent: "flex-start",
//                         background: "rgb(239 239 241)",
//                         animation: "fadeInScaleUp 0.6s ease-in-out"
//                     }}>
//                         <Typography style={{ fontSize: "13px", color: "rgb(77 92 113)" }}>{elem}</Typography>
//                     </Box>
//                 ) : ""}
//             </>

//         )
//     }
// }


class SidebarDrawer extends Component {
    constructor(props) {
        super(props);
        this.state = {
            openSideBar: true,
            sidebarActive: window.location.pathname.split('/')[window.location.pathname.split('/').length - 2].replace(".html", ""), //現在位置的人要亮
            newWindowGroupCode: null,
        }
        this.newWindowTimer = null;
    }

    componentDidMount = async () => {
        this.setState({
            openSideBar: !(await isMobile())
        })
    }

    handleDrawer = () => {
        this.setState({
            openSideBar: !this.state.openSideBar
        });
    };

    componentWillUnmount = () => {
        if (this.newWindowTimer) clearTimeout(this.newWindowTimer);
    };

    enableNewWindow = (groupCode) => {
        if (this.newWindowTimer) clearTimeout(this.newWindowTimer);
        this.newWindowTimer = setTimeout(() => {
            this.setState({ newWindowGroupCode: groupCode });
            this.newWindowTimer = null;
        }, 1200);
    };

    disableNewWindow = () => {
        if (this.newWindowTimer) clearTimeout(this.newWindowTimer);
        this.newWindowTimer = null;
        this.setState({ newWindowGroupCode: null });
    };

    handleListItemClick = async (e) => {
        // 點 sidebar 項目時要重置頁碼的紀錄
        sessionStorage.setItem("nowPage", 1);
        sessionStorage.setItem("rowsPerPage", 10);
        // 移除廠別
        sessionStorage.removeItem("plant");
        // 選取點到的人
        this.setState({
            sidebarActive: e.target.name,
            openSideBar: (isMobile() == false && this.state.openSideBar == true)
        });
    };

    render() {
        const sidebarChildActive = window.location.pathname.split('/')[window.location.pathname.split('/').length - 1].replace(".html", "");
        const sidebarShift = this.state.openSideBar ? "" : " sidebarDrawerShift";
        return (
            <div className={"sidebarDrawer" + sidebarShift} open={this.state.openSideBar}>
                <Toolbar style={{ width: 200 }} />
                <nav aria-label="mailbox folders">
                    <ul style={{ margin: 0 }}>
                        {this.props.sidebarRes.children.length === 0 ?
                            '' :
                            this.props.sidebarRes.children.filter(group => group.children.length > 0).map((group, index) => {
                                return (group.children.length > 1 ?
                                    <SidebarItem
                                        key={group.code + group.pg_id}
                                        sidebarRes={group}
                                        index={index}
                                        sidebarActive={sidebarChildActive}
                                        handleListItemClick={this.handleListItemClick}
                                    />
                                    :
                                    <NavLink
                                        key={group.children[0].code + group.children[0].page_id}
                                        isActive={(match, location) => { //跳轉到下一層路徑就不匹配了，所以要判斷
                                            let pathStrings = location.pathname.split('/');
                                            if (match) {
                                                return true;
                                            } else if (pathStrings[1] === group.code) { //選單沒有子層，只需判斷組別
                                                return true;
                                            } else {
                                                return false;
                                            }
                                        }}
                                        data-pg_id={group.children[0].pg_id}
                                        data-page_id={group.children[0].page_id}
                                        to={"/" + group.code + "/" + group.children[0].code}>
                                        <ListItem
                                            button
                                            to={"/" + group.code + "/" + group.children[0].code}
                                            className={this.state.sidebarActive === group.code ? "active" : ""}
                                            onMouseEnter={() => this.enableNewWindow(group.code)}
                                            onMouseLeave={this.disableNewWindow}
                                            onClick={(e) => this.handleListItemClick({ "target": { "name": group.code, "value": e, } })}>
                                            <ListItemText primary={group.name} />
                                            <OpenNewWindowButton
                                                url={"/" + group.code + "/" + group.children[0].code}
                                                className="nw"
                                                isNewWindowEnabled={this.state.newWindowGroupCode === group.code}
                                            />
                                        </ListItem>
                                    </NavLink>
                                )
                            }
                            )}
                    </ul>
                </nav>
            </div>
        );
    }
}

class RouterMain extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isLoaded: false,
            idb: null
        };
    }

    async componentDidMount() {
        // 取得IDB
        let idb = null
        try { idb = await get_ESD_indexedDB_factory(); }
        catch (e) { console.warn("ESD warning", e); }

        this.setState({
            isLoaded: true,
            idb
        });
    }


    /**
     * 這裡會嘗試去執行丟進來的fnArr的第i個，讀不到3次之後才讀取下一個
     * @param {*} fnArr 要import 的頁面array
     * @param {*} index 讀取的第i個
     * @param {*} interval 多久跑一次
     * @param {*} times 同一個頁面讀取次數
     * @returns 
     */
    retry(fnArr, index = 0, interval = 300, times = 0) {
        return new Promise(async (resolve, reject) => {
            // 查篩設定
            let search_set = this.state.idb !== null ?
                await this.state.idb.search("PageFilePath", [sessionStorage.getItem("home_page"), window.location.pathname, esd_storage.user_id])
                    .then(res => {
                        if (res.success) {
                            if (res.data !== null) return res.data.data;
                            else return null;
                        } else return null;
                    }) :
                null;
            // 找的到設定的話
            if (search_set !== null) {
                // 如果有紀錄，但是是超過一周的就先刪掉
                if (new Date() - search_set.date > (1000 * 60 * 60 * 24 * 7)) {
                    await this.state.idb.remove("PageFilePath", [sessionStorage.getItem("home_page"), window.location.pathname, esd_storage.user_id]);
                } else if (search_set.index <= 1) { // 只會記憶公版或是客製化版本的index
                    index = search_set.index;
                }
            }

            try {
                console.log("retry", index);
                fnArr[index]()
                    .then(async m => {
                        await this.state.idb.update("PageFilePath", {
                            home_page: sessionStorage.getItem("home_page"),
                            page: window.location.pathname,
                            user_id: esd_storage.user_id,
                            data: {
                                index: index,
                                date: new Date()
                            }
                        });
                        resolve(m);
                    })
                    .catch((error) => {
                        // 在local就不要等待直接讀下一個，並且只嘗試一次
                        if (window.location.origin.indexOf("localhost") !== -1) {
                            this.retry(fnArr, index + 1, interval, 0).then(resolve, reject);
                        } else {
                            setTimeout(() => {
                                if (index >= fnArr.length) {
                                    reject(error);
                                } else {
                                    // 同一個畫面嘗試三次
                                    if (times < 3) this.retry(fnArr, index, interval, times + 1).then(resolve, reject);
                                    else this.retry(fnArr, index + 1, interval, 0).then(resolve, reject);
                                }
                            }, interval);
                        }
                    });
            } catch (e) {
                let yes = window.confirm(e);

                if (yes) {
                    window.location = window.location.origin + "/Login";
                    window.localStorage.clear();
                    window.sessionStorage.clear();
                    window.reload();
                } else {
                    alert('你按了取消按鈕');
                }
            }
        });
    }


    render() {
        // 將 json 內有第二層頁面的人塞成同一層 (因為資料夾分類及檔案的位置)   
        let arr = new Array();
        this.props.sidebarRes.children.forEach(group => {
            group.children.forEach(page => {
                arr.push({
                    g_code: group.code,
                    child: page
                });
                page.children.forEach(pagee => {
                    if (pagee.code !== "")
                        arr.push({
                            g_code: group.code,
                            child: pagee
                        });
                })
            })
        });
        if (!this.state.isLoaded) return null;
        else {
            return <Switch>
                {this.props.sidebarRes.children.map((group, index) =>
                    // group => 頁面群組
                    arr.filter(item => item.g_code === group.code).map(item => {
                        // page => 頁面
                        let page = item.child;
                        const companyCode = (sessionStorage.company_code || "").toUpperCase();
                        const companyCodeHead = (sessionStorage.company_code_head || "").toUpperCase();

                        return (
                            <Route exact key={page.page_id}
                                path={"/" + group.code + "/" + page.code}
                                component={
                                    React.lazy(() => this.retry([
                                        () => import(`../_${companyCode}/control/${sessionStorage.home_page}/${group.code}/${page.code}`),
                                        () => import(`../_${companyCodeHead}/control/${sessionStorage.home_page}/${group.code}/${page.code}`),
                                        () => import(`../_AAA/control/${sessionStorage.home_page}/${group.code}/${page.code}`),
                                        () => import(`../_AAA/Error404`),
                                        () => import(`../_AAA/control/${sessionStorage.home_page}/${arr[0].g_code}/${arr[0].child[0].code}`),
                                    ]))
                                }
                            />)
                    })
                )}
            </Switch>;
        }
    }
}

export default withStyles(styles)(RouterMainPage);